<template>
  <Loading v-if="isLoading" />
  <div v-else>
    <handle-product-spec-sidebar ref="productSpecSidebar" />
    <handle-assign-template-sidebar ref="assignTemplateSidebar" />

    <p>
      Product recipies defines the product composition and meta data for sales
      products.
    </p>
    <vs-row vs-justify="flex-end">
      <div>
        <vs-row>
          <vs-button
            icon="add"
            @click="onClickCreateNew"
            type="relief"
            color="primary"
            class="mr-3"
            >Create new</vs-button
          >
        </vs-row>
      </div>
    </vs-row>

    <!-- table -->
    <div id="data-list-list-view" class="data-list-container">
      <vs-table
        ref="table"
        class="mt-4"
        v-model="selected"
        pagination
        search
        :max-items="8"
        :data="mappedProductSpecs"
        @selected="onClicked(selected.id)"
      >
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th sort-key="name">Name</vs-th>
          <vs-th sort-key="createdBy.username">Created by</vs-th>
          <vs-th sort-key="createdAt">Created at</vs-th>
          <vs-th>Actions</vs-th>
        </template>

        <template slot-scope="{ data }">
          <tbody>
            <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
              <vs-td>
                <div
                  class="
                    product-name
                    font-medium
                    truncate
                    flex flex-row
                    items-center
                  "
                >
                  <img
                    v-if="tr.imageUrl && tr.imageUrl !== ''"
                    style="border-radius: 5px"
                    width="80"
                    :src="tr.imageUrl"
                  />
                  <img v-else width="40" :src="ProductIcon" />
                </div>
              </vs-td>
              <vs-td>
                <div>
                  {{ tr.name }}
                </div>
              </vs-td>
              <vs-td>
                <div v-if="tr.createdBy">
                  {{ tr.createdBy.username }}
                </div>
              </vs-td>

              <vs-td>
                <div v-if="tr.createdAt" class="flex">
                  <feather-icon
                    class="mr-1"
                    :icon="'CalendarIcon'"
                    svgClasses="text-grey w-5 h-5"
                  />
                  {{ tr.createdAt | formatDate }}
                </div>
              </vs-td>
              <vs-td>
                <feather-icon
                  icon="EditIcon"
                  svgClasses="w-5 h-5 hover:text-success stroke-current"
                />
                <feather-icon
                  icon="ZapIcon"
                  svgClasses="w-5 h-5 hover:text-danger stroke-current"
                  class="ml-6"
                  @click.stop="onClickAssign(tr.id)"
                />
              </vs-td>
            </vs-tr>
          </tbody>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProductIcon from "@/assets/images/shout-icon.png";
import HandleProductSpecSidebar from "./HandleProductSpecSidebar.vue";
import HandleAssignTemplateSidebar from "./HandleAssignTemplateSidebar.vue";

export default {
  components: {
    HandleProductSpecSidebar,
    HandleAssignTemplateSidebar,
  },
  data() {
    return {
      selected: [],
      isLoading: true,
      ProductIcon,
    };
  },
  methods: {
    onClicked(id) {
      this.$refs.productSpecSidebar.show(id);
    },
    async onClickCreateNew() {
      this.$refs.productSpecSidebar.showEmpty();
    },
    async onClickAssign(id) {
      this.$refs.assignTemplateSidebar.show(id);
    },
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      units: "units/units",
      productSpecs: "productSpecs/productSpecs",
    }),

    mappedProductSpecs() {
      return this.productSpecs
        .slice()
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
    },
  },

  async created() {
    this.isLoading = true;
    await Promise.all([
      this.$store.dispatch("productSpecs/getProductSpecs"),
      this.$store.dispatch("units/getUnits"),
    ]);

    console.log("Product specs", this.productSpecs);
    this.isLoading = false;
  },
};
</script>

<style lang="scss">
.status-category {
  display: flex;
  align-items: center;
}

.status-circle {
  width: 14px;
  height: 14px;
  min-width: 14px;
  min-height: 14px;
  margin-right: 5px;
}

#data-list-list-view {
  .vs-con-table {
    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }
  }
}
</style>
